module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length > 0) ? _c('div', {
    staticClass: "folded-navigation"
  }, [_c('ul', {
    ref: "listContainer",
    staticClass: "folded-navigation--main"
  }, _vm._l((_vm.filteredItems), function(item) {
    return _c('folded-navigation-item', {
      key: item.name,
      attrs: {
        "item": item
      }
    })
  }), 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d3f46d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/FoldedNavigation.vue
// module id = 1901
// module chunks = 0